<script setup>
import {ref, onBeforeMount} from "vue"
import {invoiceStateEnum} from "@/enum/invoiceStateEnum.js";
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "6666"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("6666")
// 状态名称
const stateName = ref("未知状态")
// 订单状态枚举
const invoiceState = invoiceStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  let order = invoiceState.find(res => res.stateId === props.state)
  if (!order) {
    order = {
      stateId: "???",
      stateName: "未知状态"
    }
  }
  stateName.value = order.stateName ? order.stateName : "未知状态"
  switch (props.state) {
    case "0000":
      textType.value = "success"
      break
    case "6666":
      textType.value = "info"
      break
    case "7777":
      textType.value = "primary"
      break
    case "9999":
      textType.value = "danger"
      break
    default:
      textType.value = "info"
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>